export default class AuthSettings {
  static AD_TENANT_ID = process.env.REACT_APP_NIAGARA_AD_TENANT_ID;
  static AD_CLIENT_ID = process.env.REACT_APP_NIAGARA_AD_CLIENT_ID;
  static AD_REDIRECT_URI = process.env.REACT_APP_NIAGARA_AD_REDIRECT_URI;

  static adTenantUrl = () =>
    `https://login.microsoftonline.com/${this.AD_TENANT_ID}`;
}
